import { Outlet } from 'react-router-dom';
import Navbar from './navbar';
import Footer from './footer';
import { useAuth } from '../contexts/user-context';
import SuspendDialog from './SuspendDialog';

const Layouts = () => {
	const {user} = useAuth();
	return (
		<div className="flex min-h-screen flex-col">
			{user && user.suspend ? <SuspendDialog /> : null}
			<Navbar />
			<main className="flex-1">
				<Outlet />
			</main>
			<Footer />
		</div>
	)
}

export default Layouts
